// extracted by mini-css-extract-plugin
module.exports = {"marginSmall":"1rem","form":"LoginEmail_form__2tK5P","fullWidthFormContainer":"LoginEmail_fullWidthFormContainer__5se3T","phoneNumberLabel":"LoginEmail_phoneNumberLabel__2X0hx"};